import type {
    FollowSelectorSection as FollowSelectorSectionType,
    FollowSelectorItem as FollowSelectorItemType,
} from '../../types/follow-selector';
import { FollowSelectorItem } from './FollowSelectorItem';

interface FollowSelectorSectionProps {
    section: FollowSelectorSectionType;
    onSelect: (item: FollowSelectorItemType) => void;
    processingItemIds?: number[];
    membershipLoading?: boolean;
}

/**
 * A section in the FollowSelector with a header and list of items.
 */
export const FollowSelectorSection = ({
    section,
    onSelect,
    processingItemIds = [],
    membershipLoading = false,
}: FollowSelectorSectionProps) => {
    if (section.items.length === 0) {
        return null;
    }

    return (
        <div className="mb-3">
            <h3 className="mb-1.5 px-4.5 text-3 font-medium text-gray-900">
                {section.title}
            </h3>
            <div>
                {section.items.map((item) => (
                    <FollowSelectorItem
                        key={`${section.id}-${item.id}`}
                        item={item}
                        onSelect={onSelect}
                        isProcessing={processingItemIds.includes(item.id)}
                        membershipLoading={membershipLoading}
                    />
                ))}
            </div>
        </div>
    );
};
